import auth from '@/api/auth';

export const revalidateToken = async (params) => {
	const { refreshToken } = auth();
	try {
		const response = await refreshToken(params);

		return response.data || [];
	} catch (error) {
        return { error: true, status: error.status || error.response.status }
	}
};
